// extracted by mini-css-extract-plugin
module.exports = {"form":"Navbar_form__laHt7","searchLogo":"Navbar_searchLogo__1gs6b","clearLogo":"Navbar_clearLogo__3Ff6v","logo":"Navbar_logo__1YM9H"};